// @ts-nocheck
import React, { Suspense } from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "src/App.css";
import Banner from "src/components/common/Banner";
import "src/i18n";
import store from "src/store/store";
import GlobalStyles from "./GlobalStyles";
import AlertBox from "./components/common/AlertBox/AlertBox";

const DemoSimilarityCheckReport = React.lazy(
  () => import("src/components/pages/DemoSimilarityCheckReport")
);
const DemoGenerateAsset = React.lazy(() => import("src/components/pages/DemoGenerateAsset"));
const persistor = persistStore(store);

const App: React.FC<{}> = ({}) => {
  const CommonPage = () => (
    <Router>
      <Switch>
        <Route path="/nft-content-authenticity" component={DemoGenerateAsset} />
        <Route path="/nft-authenticity-report/:id" component={DemoSimilarityCheckReport} />
        <Route path="/" component={DemoGenerateAsset} />
      </Switch>
    </Router>
  );

  const Empty = () => {
    return <div />;
  };

  return (
    <PersistGate loading={null} persistor={persistor}>
      <GlobalStyles />
      <Suspense fallback={<Empty />}>
        <Banner />
        <CommonPage />
      </Suspense>
      <AlertBox />
      <ToastContainer />
    </PersistGate>
  );
};

export default App;
